import { money } from './logic';
import { CommandDeparture } from './types';

export function bundleTravellerNote(departure: CommandDeparture): string | null {
  const seatsOnly = Math.max(0, (departure.bundle_pax || 0) - (departure.ltle_margin_pax || 0));
  return seatsOnly > 0
    ? `Includes ${seatsOnly} traveller${seatsOnly === 1 ? '' : 's'} whose bookings are not included in margin.`
    : null;
}

export const insuranceBreakageTooltip =
  'Money we keep when a booking is cancelled with an Insurance Breakage refund: the margin kept on the booking plus the breakage amount. It is included in margin.';

export function cancellationMoneyNote(departure: CommandDeparture): string | null {
  return departure.kept_from_cancellations && departure.kept_from_cancellations > 0
    ? `Includes ${money(departure.kept_from_cancellations)} Insurance Breakage`
    : null;
}

export function cancellationMoneyCaption(departure: CommandDeparture): string | null {
  return cancellationMoneyNote(departure) ? 'Insurance Breakage in this departure' : null;
}
